import { useState } from 'react';
import { testimonials } from '@/mocks/categories';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-6 md:px-12">
        <div className="text-center mb-8 md:mb-12">
          <span className="font-heading text-base md:text-lg italic text-foreground-500">
            (Perch\u00e9 sceglierci)
          </span>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center gap-1.5 bg-foreground-900 text-background-50 px-3 py-1 rounded-full text-sm font-medium">
              <i className="ri-star-fill w-4 h-4 flex items-center justify-center text-accent-500"></i>
              {t.rating}.0
            </span>
          </div>

          <blockquote className="font-heading text-lg md:text-2xl italic text-foreground-800 leading-relaxed">
            &ldquo;{t.quote}&rdquo;
          </blockquote>

          <div className="mt-6 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center overflow-hidden">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
              <p className="text-xs text-foreground-500">{t.role}</p>
            </div>
          </div>

          <div className="mt-6 flex items-center gap-3">
            <button
              onClick={prev}
              className="w-9 h-9 rounded-lg border border-foreground-300 flex items-center justify-center hover:bg-foreground-100 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center text-foreground-700"></i>
            </button>
            <button
              onClick={next}
              className="w-9 h-9 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-background-50"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}